import {useTranslation} from '@aboutyou/i18n';
import {styled} from '@linaria/react';
import React, {FC} from 'react';
import {COLORS} from '../../../constants/colors';
import {tabletAndUpLinaria} from '../../../constants/customMedia';
import {Text} from '../../atoms/Text/Text';
import {ProductImage} from '../../molecules/ProductImage/ProductImage';

interface SoldOutInfoHeaderProps {
  productImage?: {
    src: string;
    description: string;
    isEnclosed: boolean;
  };
  hasColorOptions: boolean;
  condensed?: boolean;
}

export const SoldOutInfoHeader: FC<SoldOutInfoHeaderProps> = ({
  productImage,
  hasColorOptions,
  condensed,
}) => {
  const {t} = useTranslation();

  const colorSoldOutText = t('Your color is sold out');
  const defaultSoldOutText = t('This product is sold out');

  return (
    <Header>
      {productImage && (
        <ImageWrapper data-condensed={condensed}>
          <ProductImage
            // sold out image is only ~100px in size, 220 will even support retina devices
            widths={[220]}
            padded={productImage?.isEnclosed}
            src={productImage?.src}
            alt={productImage?.description}
          />
        </ImageWrapper>
      )}
      <Headline size="px16" weight="bold">
        {hasColorOptions ? colorSoldOutText : defaultSoldOutText}
      </Headline>
      <StyledText size="px12" color="Grey1">
        {t('We can remind you as soon as the product is back in stock.')}
      </StyledText>
    </Header>
  );
};

const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 1rem;
`;

const Headline = styled(Text)`
  display: block;
  margin-top: 2rem;
  margin-bottom: 6px;
`;

const StyledText = styled(Text)`
  line-height: 1.5;
`;

const ImageWrapper = styled.div<{$condensed?: boolean}>`
  padding: 14px;
  border-radius: 2px;
  border: 1px solid ${COLORS.Grey3};
  width: 114px;
  height: 152px;

  &[data-condensed='true'] {
    ${tabletAndUpLinaria('display: none;')}
  }
`;
